import classNames from 'classnames';
import React, { ReactElement, useEffect, useRef } from 'react';
import './Tabs.scss';
import ITabsProps from './TabsProps';

const Tabs = ({ onChange, value, sizing, children, className }: ITabsProps) => {
  const tabs = useRef<HTMLDivElement | null>();
  const currentTab = useRef(null);

  useEffect(() => {
    if (currentTab.current !== value) {
      moveLine();
      currentTab.current = value;
    }
  }, [value]);

  function renderChildren() {
    return React.Children.map(children as Array<ReactElement & { props: { value: string } }>, (child, index) => {
      function handleChange() {
        onChange(child.props.value);
      }

      return React.cloneElement(child, {
        key: index,
        onClick: handleChange,
        className: child.props.value === value ? 'tab-active' : null,
      });
    });
  }

  function moveLine() {
    setTimeout(() => {
      if (tabs.current) {
        const activeTab = tabs.current.querySelector('.tab-active') as HTMLElement | null;
        const tabLine = tabs.current.querySelector('.tab-line') as HTMLElement | null;
        if (activeTab && tabLine) {
          tabLine.style.width = activeTab.offsetWidth + 'px';
          tabLine.style.left = activeTab.offsetLeft + 'px';
          tabLine.classList.add('tab-line-moving');
          setTimeout(() => {
            tabLine.classList.remove('tab-line-moving');
          }, 150);
        }
      }
    }, 0);
  }

  const classes = classNames(
    {
      tabs: true,
      [`tabs-${sizing}`]: true,
    },
    className
  );

  return (
    <div className={classes} ref={(el) => (tabs.current = el)}>
      {renderChildren()}
      <div className="tab-line" />
    </div>
  );
};

Tabs.defaultProps = {
  sizing: 'inline',
};

export default Tabs;
